import { FaTshirt, FaUserShield, FaBoxes } from "react-icons/fa";
import { FiUsers, FiUser } from "react-icons/fi";
import { TbBrandGoogleAnalytics, TbTruckReturn } from "react-icons/tb";
import { AiOutlineHome, AiOutlineOrderedList, AiOutlineDisconnect } from "react-icons/ai";
import { BiCog, BiCategory } from "react-icons/bi";
import { MdDashboard, MdOutlineProductionQuantityLimits } from "react-icons/md";
import { ImProfile, ImTicket } from "react-icons/im";
import { B2B_REQUEST_URL, ATTRIBUTES_LISTING_URL, CATEGORIES_URL, COMPANY_LISTING_URL, COUPON_CODE_LISTING, DEFUALT_URL, HOME_PAGE_PRODUCT_LISTING, ORDER_LISTING_URL, NEWS_LISTING_URL, PROFILE_URL, PRO_CLUB_LEVEL_LISTING_URL, PRO_CLUB_USERS_LISTING_URL, RETURNED_ORDERS, SALES_LISTING_URL, USER_LISTING_URL, TAX_CLASS_URL, CAREERS_LINK, CAREERS_LISTING_LINK, CANDIDATE_LISTING_LINK, EVENT_LISTING_LINK, PRESS_RELEASE_LISTING_URL, MEDIA_WALL_LINK, CONTACT_US_LINK, INDUSTRIAL_ACCELERATOR_LISTING_LINK, PRODUCTS_LEADS_LISTING_LINK, DEPARTMENT_LISTING_LINK, BROCHURES_LISTING_URL, SPOTLIGHT_URL, SPOTLIGHT_LISTING_URL, SPONTANEOUS_CANDIDATE_LISTING_LINK, ANALYTICS_URL } from "../../constants";
import { BsGearWideConnected } from 'react-icons/bs'
import { RiUserStarLine, RiTShirtLine } from 'react-icons/ri'
import { IoTicketOutline, IoSettingsOutline } from 'react-icons/io5'
import { MdVerifiedUser } from 'react-icons/md'
import { Gi3DStairs, GiStairsGoal } from 'react-icons/gi'
// import { FaCircleDollarToSlot } from "react-icons/fa6";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { FaNewspaper } from "react-icons/fa";
import { FaGraduationCap } from "react-icons/fa";
import { PiUsersThreeDuotone } from "react-icons/pi";
import { FaUser } from "react-icons/fa6";
import { FaUsers } from "react-icons/fa";
import { MdEmojiEvents } from "react-icons/md";
import { BiSolidUserCircle } from "react-icons/bi";
import { PiMicrosoftPowerpointLogoFill } from "react-icons/pi";
import { TfiLayoutMediaRightAlt } from "react-icons/tfi";
import { TfiLayoutMediaOverlayAlt } from "react-icons/tfi";
import { MdAddIcCall } from "react-icons/md";
import { MdContactPhone } from "react-icons/md";
import { BsBuildingFillGear } from "react-icons/bs";
import { MdSatelliteAlt } from "react-icons/md";
import { SiGoogleforms } from "react-icons/si";
import { IoSettings } from "react-icons/io5";

import { MdCategory } from "react-icons/md";
import { MdOutlineManageSearch } from "react-icons/md";
import { IoNewspaperSharp } from "react-icons/io5";
import { SiSpotlight } from "react-icons/si";



export const normalLinks = [
    {
        title: "News",
        icon: FaNewspaper,
        to: NEWS_LISTING_URL
    },
    {
        title: "Press Release",
        icon: PiMicrosoftPowerpointLogoFill,
        to: PRESS_RELEASE_LISTING_URL
    },
    {
        title: "Media Wall",
        icon: TfiLayoutMediaOverlayAlt,
        to: MEDIA_WALL_LINK
    },
    {
        title: "Events",
        icon: MdEmojiEvents,
        to: EVENT_LISTING_LINK
    },
    {
        title: "Spotlights",
        icon: SiSpotlight,
        to: SPOTLIGHT_LISTING_URL
    },
    // {
    //     title: "Home Products",
    //     icon: AiOutlineOrderedList,
    //     to: HOME_PAGE_PRODUCT_LISTING
    // },
    // {
    //     title: "Sales",
    //     icon: AiOutlineDisconnect,
    //     to: SALES_LISTING_URL
    // },
    // {
    //     title: "ATTRIBUTES",
    //     icon: IoSettingsOutline,
    //     to: ATTRIBUTES_LISTING_URL
    // },
    // {
    //     title: "Coupon Code",
    //     icon: IoTicketOutline,
    //     to: COUPON_CODE_LISTING
    // },
    // {
    //     title: "Tax",
    //     icon: AiOutlineDollarCircle,
    //     to: TAX_CLASS_URL,
    // },
    // {
    //     title: "Orders",
    //     icon: MdOutlineProductionQuantityLimits,
    //     to: ORDER_LISTING_URL,
    //     // links: [
    //     //     {
    //     //         title: "All Orders",
    //     //         icon: FaBoxes,
    //     //         to: ORDER_LISTING_URL
    //     //     },
    //     //     {
    //     //         title: "Returned Orders",
    //     //         icon: TbTruckReturn,
    //     //         to: RETURNED_ORDERS
    //     //     },
    //     // ]
    // },
    // {
    //     title: "Users",
    //     icon: FaUser,
    //     to: USER_LISTING_URL,
    // },
    // {
    //     title: <span className="font-bold text-primary tracking-wider ">Club Members</span>,
    //     icon: MdVerifiedUser,
    //     to: PRO_CLUB_USERS_LISTING_URL
    // },
    // {
    //     title: "Levels",
    //     icon: GiStairsGoal,
    //     to: PRO_CLUB_LEVEL_LISTING_URL
    // },

    {
        title: "Forms",
        icon: SiGoogleforms,
        links: [
            {
                title: "Contact Us",
                icon: MdContactPhone,
                to: CONTACT_US_LINK,
            },
            {
                title: "Products",
                icon: MdSatelliteAlt,
                to: PRODUCTS_LEADS_LISTING_LINK,
            },
            // {
            //     title: "Industrial Accelerator",
            //     icon: BsBuildingFillGear,
            //     to: INDUSTRIAL_ACCELERATOR_LISTING_LINK,
            // },
            {
                title: "Brochures",
                icon: IoNewspaperSharp,
                to: BROCHURES_LISTING_URL,
            },
        ]
    },
    {
        title: "Manage Careers",
        icon: MdOutlineManageSearch,
        links: [
            {
                title: "Analytics",
                icon: TbBrandGoogleAnalytics,
                to: ANALYTICS_URL
            },
            {
                title: "Departments",
                icon: MdCategory,
                to: DEPARTMENT_LISTING_LINK,
            },
            {
                title: "Careers",
                icon: FaGraduationCap,
                to: CAREERS_LISTING_LINK,
            },
            {
                title: "Candidates",
                icon: FaUsers,
                to: CANDIDATE_LISTING_LINK,
            },
            {
                title: "Spontaneous Applications",
                icon: FaUsers,
                to: SPONTANEOUS_CANDIDATE_LISTING_LINK,
            },
        ]
    },

    {
        title: "Settings",
        icon: IoSettings,
        links: [
            {
                title: "My Profile",
                icon: BiSolidUserCircle,
                to: PROFILE_URL
            },
        ]
    },
]